import { alpha, Box, CircularProgress, Typography, useTheme } from '@mui/material'
import { amber, blue, green, grey, purple, red, lightBlue, yellow, orange } from '@mui/material/colors';
import { getContrastColor } from '../../utils/Color';
import { memo } from 'react';
import { COLORS } from '../../styles/theme';


const colors = {
    manual: lightBlue,
    automation: purple,

    passed: green,
    pass: green,
    failed: red,
    fail: red,

    skipped: yellow,
    skip: yellow,
    blocked: grey,
    not_executed: grey,

    pending: yellow,
    inprogress: blue,
    expired: red,

    active: green,
    inactive: grey,
    expiredsoon: amber,


    verified: green,
    unverified: red,


    // Schedule
    "ahead": green,
    "on-track": blue,
    "slightly-behind": yellow,
    "behind": red,

    // Scope
    //   "on-track": blue,
    "increased": orange,
    "reduced": blue,

    // Budget
    "under-budget": green,
    "on-budget": blue,
    "slightly-over": yellow,
    "over-budget": red,

    // Quality
    "excellent": green,
    "good": blue,
    "poor": red,

    // RAID
    "low-risk": green,
    "medium-risk": yellow,
    "high-risk": red,

    // Resource
    "optimal": green,
    "over-utilized": red,
    "under-utilized": yellow,
    "gaps": orange,


    high : red,
    medium : yellow,
    low : green,


    // ahead : green,
    "ontrack": blue,
    // "behind" : red,



};


function getLocalColor(status) {

    return colors[status?.trim()?.toLowerCase()]?.[900] || grey[900];
}

function Badge({ text }) {
    const theme = useTheme();

    if (!Object.keys(colors).includes(text?.toLowerCase())) {
        return (
            <Box className="flex items-center justify-center px-2  w-full overflow-hidden" >
                <Typography className="flex-1 text-center" fontWeight="bold" >{"-"}</Typography>
            </Box>
        )
    };

    return (
        <Box className="flex items-center justify-center px-2  w-full overflow-hidden" sx={{ bgcolor: alpha(getLocalColor(text), 0.1) }} borderRadius={theme.shape.borderRadius}>
            <Typography className="flex-1 flex items-center justify-center gap-1 text-center capitalize" fontWeight="bold" sx={{ color: getLocalColor(text) }}>{text?.replace('-', ' ')}</Typography>
        </Box>
    )
}

export default memo(Badge);